<script setup>
import { onMounted, defineProps } from 'vue';

//const sendEvent = inject('sendEvent');

defineProps({
  pageType: {
    type: String,
    default: '',
  }
})

onMounted(() => {
})

</script>
<template>
  <div class="top">
    <img
        :src="require(`@/assets/img/${pageType}/decor-${pageType}.png`)"
        alt=""
        :class="['top__decor', 'top__decor_desktop', `top__decor_${pageType}` ]"
    />
    <img
        :src="require(`@/assets/img/${pageType}/decor-${pageType}-mobile.png`)"
        alt=""
        :class="['top__decor', 'top__decor_mobile', `top__decor_${pageType}` ]"
    />
    <img alt="" src="@/assets/img/logo.png" class="top__logo">
  </div>
</template>